import { Box, Typography } from '@mui/material';

import { HeaderLogo } from '@components/header/HeaderLogo';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';
import { FallbackProps } from 'react-error-boundary';

export const FallbackHeader = ({ error }: FallbackProps) => {
  const { isInternalUser } = useStore((state) => state.userAuth, shallow);
  console.error(error);
  return (
    <Box
      sx={{
        position: 'static',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        height: '94px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0px 0 0 24px',
        background: ({ palette }) => palette.background.main,
        boxShadow: 'boxShadow[4]',
      }}
    >
      <HeaderLogo
        containerStyle={{ lineHeight: 0, marginRight: '16px' }}
        iconStyle={{
          height: '70px',
          width: '70px',
        }}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h5'>Something went wrong.</Typography>
        <Typography
          variant='bodySmall'
          sx={{
            color: 'white100',
          }}
        >
          There has been an issue loading the header.
        </Typography>
        {!isInternalUser && (
          <Typography
            variant='bodySmall'
            sx={{
              color: 'white100',
            }}
          >
            Please try again or contact LIO support at
            <a href='mailto:service@lioinsurance.com' style={{ marginLeft: '3px', color: 'aqua' }}>
              service@lioinsurance.com
            </a>
            , or call 877-546-7155 M-F between 8:30am - 8:00pm ET.
          </Typography>
        )}
      </Box>
    </Box>
  );
};
